/**
 * External dependencies
 */
import React, { memo } from 'react';
import Box from '@mui/material/Box';
import List from '@mui/material/List';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import LogoutIcon from '@mui/icons-material/Logout';
import useLayout from '@naruto/naruto-components/src/sxLayout';

/**
 * Internal dependencies
 */
import useLang from '@naruto/bgdcms/src/hooks/useLang';
import useData from './useData';
import SideItem from './SideItem';

function AppSideBar(): React.ReactElement {
  /* Global & Local State */
  const { i18ns } = useLang();
  const { general, mergedSx } = useLayout();
  const { mainRoutes, userIsLogin, onChangeRoute, logout } = useData();

  /* Main */
  return (
    <Box sx={{ ...mergedSx(general.FLEX_COLUMN, { p: 4, pt: 0, width: '100%', height: '100%' }) }}>
      <Box sx={{ width: '100%', height: 100, display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
        <Typography variant="body1" color="textPrimary">
          {`${i18ns.__('frontend.global.property.websitetitle')}`}
        </Typography>
      </Box>
      <Box sx={{ width: '100%', flexGrow: 1, display: 'flex', flexDirection: 'column' }}>
        <List component="nav">
          {mainRoutes.map(
            (route, index) =>
              route.showInSidebar && <SideItem key={index} item={route} parentRoute="" onChangeRoute={onChangeRoute} />
          )}
        </List>
      </Box>
      {userIsLogin && (
        <Box sx={{ width: '100%', height: 40, display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
          <Button
            variant="text"
            color="inherit"
            sx={{ ...mergedSx(general.FLEX_JUSTIFY_START) }}
            fullWidth
            onClick={logout}
          >
            <LogoutIcon fontSize="small" sx={{ mr: 2 }} />
            {i18ns.__('frontend.global.operation.logout')}
          </Button>
        </Box>
      )}
    </Box>
  );
}

export default memo(AppSideBar);
